import React, { useCallback, useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import {Navbar,Nav,Dropdown,Button,Form, Spinner} from 'react-bootstrap'
import  Card from '../../../../components/Card'
import {getDarkMode} from '../../../../store/mode'
import {connect, useDispatch} from "react-redux";

import { setLoginState, setLoginUser } from '../../../../views/backend/Auth/state/auth-slice'
import { deleteLogin } from '../../../../constants/localStorageFunctions'
import { logout } from '../../../../service/auth-service'
import { ReportingService } from '../../../../service/reporting-service'


function mapStateToProps(state) {
    return {
        darkMode: getDarkMode(state),
        config: state.auth.config
    };
}


// derive initials from full name (e.g. "John Doe" -> "JD")
const getInitials = (name = '') => {
    if (!name) return 'U'
    const parts = name.trim().split(/\s+/)
    if (parts.length === 1) return parts[0].charAt(0).toUpperCase()
    return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase()
}

// deterministic color from string
const stringToColor = (str = '') => {
    let hash = 0
    for (let i = 0; i < str.length; i++) {
        // simple hash
        hash = str.charCodeAt(i) + ((hash << 5) - hash)
    }
    const h = Math.abs(hash) % 360 // hue
    return `hsl(${h}deg 65% 45%)`
}

const formatLocalDate = (date) => {
    const yyyy = date.getFullYear()
    const mm = String(date.getMonth() + 1).padStart(2, '0')
    const dd = String(date.getDate()).padStart(2, '0')
    return `${yyyy}-${mm}-${dd}`
}

const formatItDate = (dateStr) => {
    if (!dateStr) return ''
    try {
        return new Date(dateStr).toLocaleDateString('it-IT')
    } catch (e) {
        return dateStr
    }
}

const HeaderStyle1 =(props) =>{
   const minisidbar =() =>{
    document.body.classList.toggle('sidebar-main')
}
const dispatch = useDispatch();
const history = useHistory();
const [reminders, setReminders] = useState([])
const [remindersLoading, setRemindersLoading] = useState(false)
const [remindersTotal, setRemindersTotal] = useState(0)

const loadReminders = useCallback(async () => {
    if (!props.config) return
    setRemindersLoading(true)
    try {
        const today = new Date()
        const from = new Date(today)
        from.setDate(from.getDate() - 2)
        const service = new ReportingService()
        const response = await service.getPromemoriaContacts({
            notifications: 1,
            date_from: formatLocalDate(from),
            date_to: formatLocalDate(today),
            limit: 20,
            page: 1,
        })
        setReminders(response.contacts || [])
        setRemindersTotal(response.total || 0)
    } catch (e) {
        console.error('Error loading reminder notifications', e)
        setReminders([])
        setRemindersTotal(0)
    } finally {
        setRemindersLoading(false)
    }
}, [props.config])

useEffect(() => {
    loadReminders()
    const interval = setInterval(loadReminders, 5 * 60 * 1000)
    return () => clearInterval(interval)
}, [loadReminders])

const logoutUser =async () => {
    
    await logout();
    dispatch(setLoginUser(false));
    dispatch(setLoginState(null));
    await deleteLogin()
    history.push("/auth/sign-in")

}
    // avatar initials and background color
    const userName = props.config?.name || 'User'
    const initials = getInitials(userName)
    const avatarBg = stringToColor(userName)
    const todayKey = formatLocalDate(new Date())

    return(
         <>

<div className="iq-top-navbar">
    <div className="iq-navbar-custom">
        <Navbar  expand="lg" className="navbar-light p-0">
            <div className="side-menu-bt-sidebar"  onClick={minisidbar}>
                <svg xmlns="http://www.w3.org/2000/svg" className="text-secondary wrapper-menu" width="30" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                </svg>
            </div>
            <div className="d-flex align-items-center">
                {/* <ChangeMode/>  */}
                <Navbar.Toggle  aria-controls="navbarSupportedContent">
                    <svg xmlns="http://www.w3.org/2000/svg" className="text-secondary" width="30" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7" />
                    </svg>
                </Navbar.Toggle>
                <Navbar.Collapse  id="navbarSupportedContent">
                    <Nav as="ul" className="ml-auto navbar-list align-items-center">
                        <Dropdown as="li" className="nav-item nav-icon" onToggle={(isOpen) => { if (isOpen) loadReminders() }}>
                            <Dropdown.Toggle as={Button} href="#" variant=" search-toggle" id="notification-dropdown" aria-haspopup="true" aria-expanded="false" >
                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" className="h-6 w-6 text-secondary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
                                </svg>
                                {remindersTotal > 0 && <span className="bg-primary"></span>}
                            </Dropdown.Toggle>
                            <Dropdown.Menu
                                className="iq-sub-dropdown"
                                aria-labelledby="notification-dropdown"
                                alignRight
                                style={{
                                    width: '320px',
                                    minWidth: '320px',
                                    left: 'auto',
                                    right: 0,
                                    padding: 0,
                                    border: '1px solid #e9ecef',
                                    borderRadius: '10px',
                                    boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                                    overflow: 'hidden',
                                }}
                            >
                                <div
                                    className="d-flex flex-column bg-white"
                                    style={{ maxHeight: '50vh' }}
                                >
                                    <div className="px-3 py-2 border-bottom flex-shrink-0" style={{ background: '#f8f9fa' }}>
                                        <div className="font-weight-bold text-left mb-0" style={{ fontSize: '13px' }}>
                                            Promemoria
                                            {remindersTotal > 0 ? (
                                                <span className="text-muted font-weight-normal"> · {remindersTotal}</span>
                                            ) : null}
                                        </div>
                                        <div className="text-muted text-left" style={{ fontSize: '11px' }}>
                                            Ultimi 2 giorni + oggi
                                        </div>
                                    </div>
                                    <div
                                        className="flex-grow-1"
                                        style={{ overflowY: 'auto', overflowX: 'hidden', minHeight: 0 }}
                                    >
                                        {remindersLoading ? (
                                            <div className="text-left py-3 px-3">
                                                <Spinner animation="border" size="sm" variant="primary" />
                                            </div>
                                        ) : reminders.length === 0 ? (
                                            <div className="text-muted text-left py-3 px-3" style={{ fontSize: '12px' }}>
                                                Nessun promemoria negli ultimi 2 giorni
                                            </div>
                                        ) : (
                                            <ul className="list-unstyled mb-0">
                                                {reminders.map((contact, idx) => {
                                                    const isToday = String(contact.data_per_richiamare || '').slice(0, 10) === todayKey
                                                    return (
                                                        <li
                                                            key={contact.id}
                                                            style={{
                                                                borderBottom: idx === reminders.length - 1 ? 'none' : '1px solid #f0f0f0',
                                                            }}
                                                        >
                                                            <Link
                                                                to={`/contact-view/${contact.id}`}
                                                                className="d-block text-decoration-none px-3 py-2"
                                                                style={{
                                                                    backgroundColor: isToday ? 'rgba(220, 53, 69, 0.06)' : 'transparent',
                                                                }}
                                                            >
                                                                <div className="d-flex justify-content-between align-items-start text-left" style={{ gap: '10px' }}>
                                                                    <div style={{ minWidth: 0, flex: 1 }}>
                                                                        <div
                                                                            className={isToday ? 'text-danger font-weight-bold' : 'text-dark font-weight-bold'}
                                                                            style={{ fontSize: '12px', lineHeight: 1.25 }}
                                                                        >
                                                                            {contact.name} {contact.surname}
                                                                        </div>
                                                                        <div className="text-muted text-truncate" style={{ fontSize: '11px', lineHeight: 1.25 }}>
                                                                            {contact.telefone || '—'}
                                                                            {contact.assigned_user ? ` · ${contact.assigned_user}` : ''}
                                                                        </div>
                                                                    </div>
                                                                    <span
                                                                        className={isToday ? 'text-danger' : 'text-muted'}
                                                                        style={{ fontSize: '11px', whiteSpace: 'nowrap', lineHeight: 1.25 }}
                                                                    >
                                                                        {isToday ? 'Oggi' : formatItDate(contact.data_per_richiamare)}
                                                                    </span>
                                                                </div>
                                                            </Link>
                                                        </li>
                                                    )
                                                })}
                                            </ul>
                                        )}
                                    </div>
                                    <div className="border-top px-3 py-2 flex-shrink-0" style={{ background: '#f8f9fa' }}>
                                        <Link
                                            to={"/promemoria"}
                                            className="text-primary font-weight-bold text-left d-block"
                                            style={{ fontSize: '12px' }}
                                        >
                                            Vai a Promemoria →
                                        </Link>
                                    </div>
                                </div>
                            </Dropdown.Menu>
                        </Dropdown>                        
                        {/* <Dropdown as="li" className="nav-item nav-icon">
                            <Dropdown.Toggle  as={Button} href="#" variant=" search-toggle" id="dropdownMenuButton2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <img src={flag1} className="img-fluid rounded-circle" alt="user" style={{height: "30px", minWidth: "30px", width: "30px"}}/>
                            <span className="bg-primary"></span>
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="iq-sub-dropdown" aria-labelledby="dropdownMenuButton2">
                                <Card className="shadow-none m-0 border-0">
                                    <div className=" p-0 ">
                                        <ul className="dropdown-menu-1 list-group list-group-flush">
                                            <li className="dropdown-item-1 list-group-item  px-2"><Link className="p-0" to="#"><img src={flag3} alt="img-flaf" className="img-fluid mr-2" width= "15px" height= "15px" min-width= "15px"/>Spanish</Link></li>
                                            <li className="dropdown-item-1 list-group-item  px-2"><Link className="p-0" to="#"><img src={flag4} alt="img-flaf" className="img-fluid mr-2" width= "15px" height= "15px" min-width= "15px"/>Italian</Link></li>
                                            <li className="dropdown-item-1 list-group-item  px-2"><Link className="p-0" to="#"><img src={flag2} alt="img-flaf" className="img-fluid mr-2" width= "15px" height= "15px" min-width= "15px"/>French</Link></li>
                                            <li className="dropdown-item-1 list-group-item  px-2"><Link className="p-0" to="#"><img src={flag5} alt="img-flaf" className="img-fluid mr-2" width= "15px" height= "15px" min-width= "15px"/>German</Link></li>
                                            <li className="dropdown-item-1 list-group-item  px-2"><Link className="p-0" to="#"><img src={flag6} alt="img-flaf" className="img-fluid mr-2" width= "15px" height= "15px" min-width= "15px"/>Japanese</Link></li>
                                        </ul>
                                    </div>
                                </Card>
                            </Dropdown.Menu>
                        </Dropdown> */}
                        <Dropdown as="li" bsPrefix="nav-item nav-icon search-content">
                            <Dropdown.Toggle as={Button} href="#" variant=" search-toggle rounded" id="dropdownSearch" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <svg className="svg-icon text-secondary" id="h-suns" height="25" width="25" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                </svg>
                            </Dropdown.Toggle>
                            <Dropdown.Menu  className="iq-search-bar iq-sub-dropdown " aria-labelledby="dropdownSearch">
                                <Form action="#" className="searchbox p-2">
                                    <Form.Group className="mb-0 position-relative">
                                    <Form.Control  type="text" className="text search-input font-size-12" placeholder="type here to search..."/>
                                    <Link to="#" className="search-link">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="" width="20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                        </svg>
                                    </Link> 
                                    </Form.Group>
                                </Form>
                            </Dropdown.Menu>
                        </Dropdown>
                        <Dropdown as="li" className="nav-item nav-icon">
                            <Dropdown.Toggle  as={Button} href="#" variant="nav-item nav-icon pr-0 search-toggle" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" >
                                <div
                                    className="img-fluid avatar-rounded"
                                    style={{
                                        width: '40px',
                                        height: '40px',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        borderRadius: '50%',
                                        backgroundColor: avatarBg,
                                        color: '#fff',
                                        fontWeight: 600,
                                        textTransform: 'uppercase'
                                    }}
                                >
                                    {initials}
                                </div>
                                <span className="mb-0 ml-2 user-name">{userName}</span>
                            </Dropdown.Toggle>
                            <Dropdown.Menu as="ul"  className="dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                                <Dropdown.Item as={Link} to="/profile" className="d-flex svg-icon">
                                    <svg className="svg-icon mr-0 text-secondary" id="h-01-p" width="20" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                    </svg>
                                    <h6 className="ml-2">Profilo</h6>
                                </Dropdown.Item>
                                <Dropdown.Item as="li" className="d-flex svg-icon" onClick={logoutUser}>
                                    <svg className="svg-icon mr-0 text-secondary" id="h-05-p" width="20" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                                    </svg>
                                    <h6>Esci</h6>
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </Nav>                     
                </Navbar.Collapse> 
            </div>
        </Navbar>
    </div>
</div>


        </>
    )
}

// export default HeaderStyle1
export default connect(mapStateToProps)(HeaderStyle1)